import FormPasswordStrengthIndicator from './FormPasswordStrengthIndicator';

export default FormPasswordStrengthIndicator;
